<ng-container *ngIf="selectedDepartment">
  <div class="department-info-wrapper">
    <div class="department-name">
      <label for="departmentName">Department</label>
      <input
        id="departmentName"
        type="text"
        class="item"
        size="30"
        value="{{ selectedDepartment }}"
        disabled
      />
    </div>
  </div>
</ng-container>
